module.exports = __webpack_public_path__ + "img/docm77-52508005-6a52-4e80-ddf2-08d959eef549.png";